'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Number$isInteger = _interopDefault(require('babel-runtime/core-js/number/is-integer'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');
var Config = _interopDefault(require('./config.js'));

var EVENT_NAMESPACE = 'analytics';
var SELECTORS = {
  external: '[data-ga-event], [data-ga-category]'
};

function trackGA(eventData) {
  if (!$.isFunction(window._gaUTracker)) {
    return;
  }

  var customNamespace = Config.get('customGoogleAnalyticsNamespace', null);
  var trackingData = _Object$assign({}, Config.get('defaultGoogleAnalyticsEventData', null));

  _Object$assign(trackingData, eventData);

  window._gaUTracker('send', 'event', trackingData);

  if (customNamespace) {
    window._gaUTracker(customNamespace + '.send', 'event', trackingData);
  }
}

var Analytics = function () {

  /**
   * The Analytics component assists with tracking events with Google Analytics.
   *
   * @class Analytics
   * @constructor
   */
  function Analytics() {
    _classCallCheck(this, Analytics);

    this.trackExternal();
  }

  /**
   * Use track when you want to record an event to Google Analytics.
   *
   * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/events#event_fields
   * @method track
   * @param  {string|object}  category
   *  Typically the object that was interacted with, or a full eventData object.
   * @param  {string}  action
   *  The type of interaction
   * @param  {string}  label
   *  Useful for categorizing events
   * @param  {integer} value
   *  A numeric value associated with the event
   * @param  {boolean} [nonInteraction=false]
   *  Whether this event will count a user interaction or not, affects bounce rate calculations
   */


  _createClass(Analytics, [{
    key: 'track',
    value: function track(category, action, label, value) {
      var nonInteraction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var eventData = void 0;

      if (utils_js.isObject(category)) {
        eventData = category;
      } else {
        eventData = {
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          eventValue: _Number$isInteger(value) && value,
          nonInteraction: nonInteraction
        };
      }

      eventData = _Object$keys(eventData).reduce(function (result, key) {
        var val = eventData[key];
        if (val) {
          result[key] = val;
        }
        return result;
      }, {});

      return trackGA(eventData);
    }

    /**
     * Track external clicks from elements that have data attributes `ga-event` or
     * `ga-category` present. These links can specify data attributes `ga-action`,
     * `ga-label` and `ga-value` which will pass through as event data.
     *
     * Note `ga-event` is preferred to `ga-category`.
     *
     * @method trackExternal
     */

  }, {
    key: 'trackExternal',
    value: function trackExternal() {
      var _this = this;

      $(document.body).on('click.' + EVENT_NAMESPACE, SELECTORS.external, function (evt) {
        var data = $(evt.currentTarget).data();

        _this.track(data.gaEvent || data.gaCategory, data.gaAction, data.gaLabel, data.gaValue);
      });
    }
  }]);

  return Analytics;
}();

var analytics = new Analytics();

module.exports = analytics;
